import React, { useEffect, useRef } from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Helpers from "../utility/Helpers"
import FooterContact from './../common/FooterContact';
import Loader2 from './../common/Loader2'
import { GetKeyResults } from "../services/Service"
import NavigationMenu from '../NavigationMenu';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Line } from 'react-chartjs-2';
import 'chart.js/auto';

const backgroundPictures = [
    "physical-health-image.png",
    "mental-health-image.png",
    "family-image.png",
    "social-relationship-image.png",
    "fulfilment-image.png",
    "environment-image.png",
    "career-business-aspiration-image.png",
    "financial-status-image.png",
    "decision-making-image.png",
    "sustainability-image.png"
];
const backgroundColor =[//CategoryIndex>WheelItemIndex
    '#7d9cc1',      //0
    '#b16d95',      //1
    '#f5ca77',      //2
    '#a9ddf4',      //3
    '#f0a741',      //4
    '#75a188',      //5
    '#e26f8e',      //6
    '#4080a0',      //7
    '#ee8d72',      //8
    '#9bc473',      //9
  ];

function ScoreLines(props) {
    const [keyResultData, setKeyResultData] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [markLabelColor,] = React.useState("#ffffff");
    const [markLabelColorBlack,] = React.useState("#5F5D5B");
    const [userName, setUserName] = React.useState("");
    const [displayDownload, setDisplayDownload] = React.useState('block');
    const [dateToday,] = React.useState(new Date().toLocaleDateString('en-GB'));

    const [data1, setData1] = React.useState({});
    const [data2, setData2] = React.useState({});
    const [data3, setData3] = React.useState({});
    const [data4, setData4] = React.useState({});
    const [data5, setData5] = React.useState({});
    const [data6, setData6] = React.useState({});
    const [data7, setData7] = React.useState({});
    const [data8, setData8] = React.useState({});
    const [data9, setData9] = React.useState({});
    const [data10, setData10] = React.useState({});

    const chartHeadingRef = useRef();
    const chartRef1 = useRef();
    const chartRef2 = useRef();
    const chartRef3 = useRef();
    const chartRef4 = useRef();
    const chartRef5 = useRef();
    const chartRef6 = useRef();
    const chartRef7 = useRef();
    const chartRef8 = useRef();
    const chartRef9 = useRef();
    const chartRef10 = useRef();

    useEffect(() => {

        if (keyResultData.length < 1) {
            setIsLoading(true);
            let ReportData=[];
            GetKeyResults(0).then((res) => {
                setKeyResultData(res.data);
                ReportData=res.data;

                let dt1 = [null];
                let dt2 = [null];
                let dt3 = [null];
                let dt4 = [null];
                let dt5 = [null];
                let dt6 = [null];
                let dt7 = [null];
                let dt8 = [null];
                let dt9 = [null];
                let dt10 = [null];

                let dateLabels = ['']; //Marker Labels

                let kdata1 = ReportData.find(item => item.categoryId === 1);
                let kdata2 = ReportData.find(item => item.categoryId === 2);
                let kdata3 = ReportData.find(item => item.categoryId === 3);
                let kdata4 = ReportData.find(item => item.categoryId === 4);
                let kdata5 = ReportData.find(item => item.categoryId === 5);
                let kdata6 = ReportData.find(item => item.categoryId === 6);
                let kdata7 = ReportData.find(item => item.categoryId === 7);
                let kdata8 = ReportData.find(item => item.categoryId === 8);
                let kdata9 = ReportData.find(item => item.categoryId === 9);
                let kdata10 = ReportData.find(item => item.categoryId === 10);
                for (let i = 0; i < kdata1.dateScores.length; i++) {
                    dateLabels.push(kdata1.dateScores[i].date);
                    dt1.push(kdata1.dateScores[i].score);
                }
                dateLabels.push('');

                for (let i = 0; i < kdata2.dateScores.length; i++) {
                    dt2.push(kdata2.dateScores[i].score);
                }
                for (let i = 0; i < kdata3.dateScores.length; i++) {
                    dt3.push(kdata3.dateScores[i].score);
                }
                for (let i = 0; i < kdata4.dateScores.length; i++) {
                    dt4.push(kdata4.dateScores[i].score);
                }
                for (let i = 0; i < kdata5.dateScores.length; i++) {
                    dt5.push(kdata5.dateScores[i].score);
                }
                for (let i = 0; i < kdata6.dateScores.length; i++) {
                    dt6.push(kdata6.dateScores[i].score);
                }
                for (let i = 0; i < kdata7.dateScores.length; i++) {
                    dt7.push(kdata7.dateScores[i].score);
                }
                for (let i = 0; i < kdata8.dateScores.length; i++) {
                    dt8.push(kdata8.dateScores[i].score);
                }
                for (let i = 0; i < kdata9.dateScores.length; i++) {
                    dt9.push(kdata9.dateScores[i].score);
                }
                for (let i = 0; i < kdata10.dateScores.length; i++) {
                    dt10.push(kdata10.dateScores[i].score);
                }
                

               
                let datasets1 = [
                    {
                        data: dt1,
                        fill: false,
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: 3,
                        pointBackgroundColor: 'rgb(88, 88, 90)',
                        pointBorderColor: 'rgba(255,255,255,1)',
                        pointBorderWidth: 3,
                        pointRadius: 12,
                        pointHoverRadius: 15,
                    },
                ];
                let datasets2 = [
                    {
                        data: dt2,
                        fill: false,
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: 3,
                        pointBackgroundColor: 'rgb(88, 88, 90)',
                        pointBorderColor: 'rgba(255,255,255,1)',
                        pointBorderWidth: 3,
                        pointRadius: 12,
                        pointHoverRadius: 15,
                    },
                ];
                let datasets3 = [
                    {
                        data: dt3,
                        fill: false,
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: 3,
                        pointBackgroundColor: 'rgb(88, 88, 90)',
                        pointBorderColor: 'rgba(255,255,255,1)',
                        pointBorderWidth: 3,
                        pointRadius: 12,
                        pointHoverRadius: 15,
                    },
                ];
                let datasets4 = [
                    {
                        data: dt4,
                        fill: false,
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: 3,
                        pointBackgroundColor: 'rgb(88, 88, 90)',
                        pointBorderColor: 'rgba(255,255,255,1)',
                        pointBorderWidth: 3,
                        pointRadius: 12,
                        pointHoverRadius: 15,
                    },
                ];
                let datasets5 = [
                    {
                        data: dt5,
                        fill: false,
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: 3,
                        pointBackgroundColor: 'rgb(88, 88, 90)',
                        pointBorderColor: 'rgba(255,255,255,1)',
                        pointBorderWidth: 3,
                        pointRadius: 12,
                        pointHoverRadius: 15,
                    },
                ];
                let datasets6 = [
                    {
                        data: dt6,
                        fill: false,
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: 3,
                        pointBackgroundColor: 'rgb(88, 88, 90)',
                        pointBorderColor: 'rgba(255,255,255,1)',
                        pointBorderWidth: 3,
                        pointRadius: 12,
                        pointHoverRadius: 15,
                    },
                ];
                let datasets7 = [
                    {
                        data: dt7,
                        fill: false,
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: 3,
                        pointBackgroundColor: 'rgb(88, 88, 90)',
                        pointBorderColor: 'rgba(255,255,255,1)',
                        pointBorderWidth: 3,
                        pointRadius: 12,
                        pointHoverRadius: 15,
                    },
                ];
                let datasets8 = [
                    {
                        data: dt8,
                        fill: false,
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: 3,
                        pointBackgroundColor: 'rgb(88, 88, 90)',
                        pointBorderColor: 'rgba(255,255,255,1)',
                        pointBorderWidth: 3,
                        pointRadius: 12,
                        pointHoverRadius: 15,
                    },
                ];
                let datasets9 = [
                    {
                        data: dt9,
                        fill: false,
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: 3,
                        pointBackgroundColor: 'rgb(88, 88, 90)',
                        pointBorderColor: 'rgba(255,255,255,1)',
                        pointBorderWidth: 3,
                        pointRadius: 12,
                        pointHoverRadius: 15,
                    },
                ];
                let datasets10 = [
                    {
                        data: dt10,
                        fill: false,
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: 3,
                        pointBackgroundColor: 'rgb(88, 88, 90)',
                        pointBorderColor: 'rgba(255,255,255,1)',
                        pointBorderWidth: 3,
                        pointRadius: 12,
                        pointHoverRadius: 15,
                    },
                ];
                let chartdt1 = { labels: dateLabels, datasets: datasets1 };
                let chartdt2 = { labels: dateLabels, datasets: datasets2 };
                let chartdt3 = { labels: dateLabels, datasets: datasets3 };
                let chartdt4 = { labels: dateLabels, datasets: datasets4 };
                let chartdt5 = { labels: dateLabels, datasets: datasets5 };
                let chartdt6 = { labels: dateLabels, datasets: datasets6 };
                let chartdt7 = { labels: dateLabels, datasets: datasets7 };
                let chartdt8 = { labels: dateLabels, datasets: datasets8 };
                let chartdt9 = { labels: dateLabels, datasets: datasets9 };
                let chartdt10 = { labels: dateLabels, datasets: datasets10 };

                //final values
                setData1(chartdt1);
                setData2(chartdt2);
                setData3(chartdt3);
                setData4(chartdt4);
                setData5(chartdt5);
                setData6(chartdt6);
                setData7(chartdt7);
                setData8(chartdt8);
                setData9(chartdt9);
                setData10(chartdt10);

                setUserName(sessionStorage.getItem('userName'));
                setIsLoading(false);
            }).catch((error) => { Helpers.handleError(error); setIsLoading(false);});
        }
    }, [keyResultData.length]);

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 0.9,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            y: {
                suggestedMin: 0,
                suggestedMax: 11,
                beginAtZero: true,
                border: {
                    width: 3,
                    color: '#ffffff'
                },
                grid: {
                    display: false,
                    drawBorder: true,
                    borderColor: 'rgb(255, 255, 255)',
                    color: 'rgb(255, 255, 255)',
                    lineWidth: 2,
                },
                ticks: {

                    display: false,
                },
            },
            x: {
                //   afterFit: (scale) => {
                //     scale.height = 120;
                // },
                afterBuildTicks: (axis) => {
                    if (axis.ticks && axis.ticks.length > 1) {
                        axis.ticks.pop(); // Remove the last tick
                        axis.ticks = axis.ticks.slice(1);
                    }

                },
                border: {
                    width: 3,
                    color: '#ffffff'
                },
                grid: {
                    drawOnChartArea: false,
                    color: 'rgb(255, 255, 255)',
                    lineWidth: 3,
                    tickLength: 20,

                },
                ticks: {
                    padding: 10,
                    length: 20,
                    fontColor: 'rgb(255, 255, 255)',
                    color: markLabelColor, ////change color of label
                    font: {
                        size: 18,
                    },
                    callback: function (value) {
                        return this.getLabelForValue(value);
                    },
                    maxRotation: 90,
                    minRotation: 90,
                },
            },
        },
    };
    const optionsBlack = {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 0.9,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            y: {
                suggestedMin: 0,
                suggestedMax: 11,
                beginAtZero: true,
                border: {
                    width: 3,
                    color: '#ffffff'
                },
                grid: {
                    display: false,
                    drawBorder: true,
                    borderColor: 'rgb(255, 255, 255)',
                    color: 'rgb(255, 255, 255)',
                    lineWidth: 2,
                },
                ticks: {

                    display: false,
                },
            },
            x: {
                //   afterFit: (scale) => {
                //     scale.height = 120;
                // },
                afterBuildTicks: (axis) => {
                    if (axis.ticks && axis.ticks.length > 1) {
                        axis.ticks.pop(); // Remove the last tick
                        axis.ticks = axis.ticks.slice(1);
                    }

                },
                border: {
                    width: 3,
                    color: '#ffffff'
                },
                grid: {
                    drawOnChartArea: false,
                    color: 'rgb(255, 255, 255)',
                    lineWidth: 3,
                    tickLength: 20,

                },
                ticks: {
                    padding: 10,
                    length: 20,
                    fontColor: 'rgb(255, 255, 255)',
                    color: markLabelColorBlack, ////change color of label
                    font: {
                        size: 18,
                    },
                    callback: function (value) {
                        return this.getLabelForValue(value);
                    },
                    maxRotation: 90,
                    minRotation: 90,
                },
            },
        },
    };
    const handleGeneratePDF = () => {
        setIsLoading(true);
        setDisplayDownload('none');
        setTimeout(() => {
        const excludedElements = document.querySelectorAll('.inclide-in-pdf');
        excludedElements.forEach(el => el.style.display = 'block');
        
        generatePagedPDF([chartHeadingRef,chartRef1, chartRef2,chartRef3,chartRef4,chartRef5,chartRef6,chartRef7,chartRef8,chartRef9,chartRef10]);
        excludedElements.forEach(el => el.style.display = 'none'); 
    }, 100);
      };
    const generatePagedPDF = (refs) => {
        const pdfdateToday=dateToday.replace(/\//g, '-');
        const pdf = new jsPDF('p', 'mm', [210, 305]);
        const promises = refs.map((ref, index) => {
          return html2canvas(ref.current,{willReadFrequently:true,useCORS: true}).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            if (index > 0) {
              pdf.addPage();
            }
            const imgWidth = 210; // A4 width in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
          }).catch((error) => {
            console.error('Error generating image:', error);
          });
        });
      
        setTimeout(() => {

        Promise.allSettled(promises).then((results) => {
            results.forEach((result) => {
                if (result.status === 'fulfilled') {
                  console.log('Image added:', result.value);
                } else {
                  console.error('Error adding image:', result.reason);
                }
              });
          pdf.save('AllScoreLines-'+pdfdateToday+'.pdf');
          setIsLoading(false);
          setDisplayDownload('block');
        });

        }, 300);

      };

    return (<>
        <Box width='100%'
            display='flex'
            justifyContent='center'>
            <NavigationMenu pageName={"Score Lines"} />
            <Box className="pageContainer2">
                <Box width='100%' sx={{paddingTop:{ xs: '80px', sm: '45px' }}} >

                    <Box 
                        paddingBottom='30px'
                        width='100%'
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                            gap: 2,
                            //padding: 2,
                            paddingTop: 2,
                            paddingBottom: 2,
                            paddingLeft: { xs: 0, sm: 2 },
                            paddingRight: { xs: 0, sm: 2 },
                            backgroundColor: '#DFECFF'
                        }}
                    >
                        <Box ref={chartHeadingRef} className='inclide-in-pdf' width='100%'
                                    display='flex'
                                    justifyContent='space-between !important' paddingTop='30px' sx={{textAlign:'center', display:'none', fontWeight: '600', fontSize:'26px',backgroundColor:'#ffffff'}}>

                                        DECAMA<br/>
                                        WELLBEING REPORT<br/>
                                        of<br/>
                                        <Typography sx={{ fontWeight: '500', fontFamily: 'Quicksand', fontSize: "28px", paddingLeft: '16px' }}>
                                        {userName}
                                        </Typography>
                                        <br/><br/>Created on<br/>
                                        {dateToday}
                                    </Box>
                        {data1.datasets !== undefined && (<>

                            <Box ref={chartRef1} 
                            
                            className="section"
                                width='auto'
                               
                                justifyContent='center'
                                sx={{ maxWidth: '400px', width:'100%', backgroundColor: backgroundColor[0] }}
                            >

                                <Box width='100%'
                                    display='flex'
                                    justifyContent='space-between !important' paddingTop='5px'>
                                    <Box sx={{ maxWidth: '200px' }}>
                                        <Typography sx={{ fontWeight: '400', textTransform: 'uppercase', fontFamily: 'Quicksand', fontSize: "18px", color: markLabelColor, paddingLeft: '16px' }}>
                                            PHYSICAL HEALTH
                                        </Typography>
                                        <Typography sx={{ fontWeight: '400', fontFamily: 'Quicksand', fontSize: "26px", color: markLabelColor, paddingLeft: '16px' }}>
                                            OVERVIEW
                                        </Typography>
                                    </Box>

                                    <Box component="img" sx={{ display: { xs: 'none', sm: 'block' } }} alt="Org Image" src={process.env.PUBLIC_URL + "/images/blank.png"} />

                                    <Box component="img"
                                        sx={{ display: "flex", height: '130px', paddingTop: '20px' }}
                                        alt="Org Image" src={process.env.PUBLIC_URL + "/images/"+backgroundPictures[0]} />
                                </Box>
                                <Box width='100%'>
                                    <Line data={data1} options={options} />
                                </Box>
                            </Box>
                            <Box ref={chartRef2} className="section"
                                width='auto'
                               
                                justifyContent='center'
                                sx={{ maxWidth: '400px', width:'100%', backgroundColor: backgroundColor[1] }}
                            >
                                <Box width='100%'
                                    display='flex'
                                    justifyContent='space-between !important' paddingTop='5px'>
                                    <Box sx={{ maxWidth: '200px' }}>
                                        <Typography sx={{ fontWeight: '400', textTransform: 'uppercase', fontFamily: 'Quicksand', fontSize: "18px", color: markLabelColor, paddingLeft: '16px' }}>
                                            MENTAL HEALTH
                                        </Typography>
                                        <Typography sx={{ fontWeight: '400', fontFamily: 'Quicksand', fontSize: "26px", color: markLabelColor, paddingLeft: '16px' }}>
                                            OVERVIEW
                                        </Typography>
                                    </Box>

                                    <Box component="img" sx={{ display: { xs: 'none', sm: 'block' } }} alt="Org Image" src={process.env.PUBLIC_URL + "/images/blank.png"} />

                                    <Box component="img"
                                        sx={{ display: "flex", height: '130px', paddingTop: '20px' }}
                                        alt="Org Image" src={process.env.PUBLIC_URL + "/images/"+backgroundPictures[1]} />
                                </Box>

                                <Box width='100%'>
                                <Line data={data2} options={options} />
                                </Box>
                            </Box>
                            <Box ref={chartRef3} className="section"
                                width='auto'
                               
                                justifyContent='center'
                                sx={{ maxWidth: '400px', width:'100%', backgroundColor: backgroundColor[2] }}
                            >
                                <Box width='100%'
                                    display='flex'
                                    justifyContent='space-between !important' paddingTop='5px'>
                                    <Box sx={{ maxWidth: '200px' }}>
                                        <Typography sx={{ fontWeight: '400', textTransform: 'uppercase', fontFamily: 'Quicksand', fontSize: "18px", color: markLabelColorBlack, paddingLeft: '16px' }}>
                                            FAMILY
                                        </Typography>
                                        <Typography sx={{ fontWeight: '400', fontFamily: 'Quicksand', fontSize: "26px", color: markLabelColorBlack, paddingLeft: '16px' }}>
                                            OVERVIEW
                                        </Typography>
                                    </Box>

                                    <Box component="img" sx={{ display: { xs: 'none', sm: 'block' } }} alt="Org Image" src={process.env.PUBLIC_URL + "/images/blank.png"} />

                                    <Box component="img"
                                        sx={{ display: "flex", height: '130px', paddingTop: '20px' }}
                                        alt="Org Image" src={process.env.PUBLIC_URL + "/images/"+backgroundPictures[2]} />
                                </Box>
                                <Box width='100%'>
                                <Line data={data3} options={optionsBlack} />
                                </Box>
                            </Box>
                            <Box ref={chartRef4} className="section"
                                width='auto'
                           
                                justifyContent='center'
                                sx={{ maxWidth: '400px', width:'100%', backgroundColor: backgroundColor[3] }}
                            >
                                <Box width='100%'
                                    display='flex'
                                    justifyContent='space-between !important' paddingTop='5px'>
                                    <Box sx={{ maxWidth: '200px' }}>
                                        <Typography sx={{ fontWeight: '400', textTransform: 'uppercase', fontFamily: 'Quicksand', fontSize: "18px", color: markLabelColorBlack, paddingLeft: '16px' }}>
                                            SOCIAL RELATIONSHIP
                                        </Typography>
                                        <Typography sx={{ fontWeight: '400', fontFamily: 'Quicksand', fontSize: "26px", color: markLabelColorBlack, paddingLeft: '16px' }}>
                                            OVERVIEW
                                        </Typography>
                                    </Box>

                                    <Box component="img" sx={{ display: { xs: 'none', sm: 'block' } }} alt="Org Image" src={process.env.PUBLIC_URL + "/images/blank.png"} />

                                    <Box component="img"
                                        sx={{ display: "flex", height: '130px', paddingTop: '20px' }}
                                        alt="Org Image" src={process.env.PUBLIC_URL + "/images/"+backgroundPictures[3]} />
                                </Box>
                                <Box width='100%'>
                                <Line data={data4} options={optionsBlack} />
                                </Box>
                            </Box>

                            <Box ref={chartRef5} className="section"
                                width='auto'
                           
                                justifyContent='center'
                                sx={{ maxWidth: '400px', width:'100%', backgroundColor: backgroundColor[4] }}
                            >
                                <Box width='100%'
                                    display='flex'
                                    justifyContent='space-between !important' paddingTop='5px'>
                                    <Box sx={{ maxWidth: '200px' }}>
                                        <Typography sx={{ fontWeight: '400', textTransform: 'uppercase', fontFamily: 'Quicksand', fontSize: "18px", color: markLabelColor, paddingLeft: '16px' }}>
                                            FULFILMENT
                                        </Typography>
                                        <Typography sx={{ fontWeight: '400', fontFamily: 'Quicksand', fontSize: "26px", color: markLabelColor, paddingLeft: '16px' }}>
                                            OVERVIEW
                                        </Typography>
                                    </Box>

                                    <Box component="img" sx={{ display: { xs: 'none', sm: 'block' } }} alt="Org Image" src={process.env.PUBLIC_URL + "/images/blank.png"} />

                                    <Box component="img"
                                        sx={{ display: "flex", height: '130px', paddingTop: '20px' }}
                                        alt="Org Image" src={process.env.PUBLIC_URL + "/images/"+backgroundPictures[4]} />
                                </Box>
                                <Box width='100%'>
                                <Line data={data5} options={options} />
                                </Box>
                            </Box>

                            <Box ref={chartRef6} className="section"
                                width='auto'
                           
                                justifyContent='center'
                                sx={{ maxWidth: '400px', width:'100%', backgroundColor: backgroundColor[5] }}
                            >
                                <Box width='100%'
                                    display='flex'
                                    justifyContent='space-between !important' paddingTop='5px'>
                                    <Box sx={{ maxWidth: '200px' }}>
                                        <Typography sx={{ fontWeight: '400', textTransform: 'uppercase', fontFamily: 'Quicksand', fontSize: "18px", color: markLabelColor, paddingLeft: '16px' }}>
                                            ENVIRONMENT
                                        </Typography>
                                        <Typography sx={{ fontWeight: '400', fontFamily: 'Quicksand', fontSize: "26px", color: markLabelColor, paddingLeft: '16px' }}>
                                            OVERVIEW
                                        </Typography>
                                    </Box>

                                    <Box component="img" sx={{ display: { xs: 'none', sm: 'block' } }} alt="Org Image" src={process.env.PUBLIC_URL + "/images/blank.png"} />

                                    <Box component="img"
                                        sx={{ display: "flex", height: '130px', paddingTop: '20px' }}
                                        alt="Org Image" src={process.env.PUBLIC_URL + "/images/"+backgroundPictures[5]} />
                                </Box>
                                <Box width='100%'>
                                <Line data={data6} options={options} />
                                </Box>
                            </Box>

                            <Box ref={chartRef7} className="section"
                                width='auto'
                           
                                justifyContent='center'
                                sx={{ maxWidth: '400px', width:'100%', backgroundColor: backgroundColor[6] }}
                            >
                                <Box width='100%'
                                    display='flex'
                                    justifyContent='space-between !important' paddingTop='5px'>
                                    <Box sx={{ maxWidth: '200px' }}>
                                        <Typography sx={{ fontWeight: '400', textTransform: 'uppercase', fontFamily: 'Quicksand', fontSize: "18px", color: markLabelColor, paddingLeft: '16px' }}>
                                            CAREER & BUSINESS ASPIRATIONS
                                        </Typography>
                                        <Typography sx={{ fontWeight: '400', fontFamily: 'Quicksand', fontSize: "26px", color: markLabelColor, paddingLeft: '16px' }}>
                                            OVERVIEW
                                        </Typography>
                                    </Box>

                                    <Box component="img" sx={{ display: { xs: 'none', sm: 'block' } }} alt="Org Image" src={process.env.PUBLIC_URL + "/images/blank.png"} />

                                    <Box component="img"
                                        sx={{ display: "flex", height: '130px', paddingTop: '20px' }}
                                        alt="Org Image" src={process.env.PUBLIC_URL + "/images/"+backgroundPictures[6]} />
                                </Box>
                                <Box width='100%'>
                                <Line data={data7} options={options} />
                                </Box>
                            </Box>

                            <Box ref={chartRef8} className="section"
                                width='auto'
                           
                                justifyContent='center'
                                sx={{ maxWidth: '400px', width:'100%', backgroundColor: backgroundColor[7] }}
                            >
                                <Box width='100%'
                                    display='flex'
                                    justifyContent='space-between !important' paddingTop='5px'>
                                    <Box sx={{ maxWidth: '200px' }}>
                                        <Typography sx={{ fontWeight: '400', textTransform: 'uppercase', fontFamily: 'Quicksand', fontSize: "18px", color: markLabelColor, paddingLeft: '16px' }}>
                                            FINANCIAL STATUS
                                        </Typography>
                                        <Typography sx={{ fontWeight: '400', fontFamily: 'Quicksand', fontSize: "26px", color: markLabelColor, paddingLeft: '16px' }}>
                                            OVERVIEW
                                        </Typography>
                                    </Box>

                                    <Box component="img" sx={{ display: { xs: 'none', sm: 'block' } }} alt="Org Image" src={process.env.PUBLIC_URL + "/images/blank.png"} />

                                    <Box component="img"
                                        sx={{ display: "flex", height: '130px', paddingTop: '20px' }}
                                        alt="Org Image" src={process.env.PUBLIC_URL + "/images/"+backgroundPictures[7]} />
                                </Box>
                                <Box width='100%'>
                                <Line data={data8} options={options} />
                                </Box>
                            </Box>

                            <Box ref={chartRef9} className="section"
                                width='auto'
                           
                                justifyContent='center'
                                sx={{ maxWidth: '400px', width:'100%', backgroundColor: backgroundColor[8] }}
                            >
                                <Box width='100%'
                                    display='flex'
                                    justifyContent='space-between !important' paddingTop='5px'>
                                    <Box sx={{ maxWidth: '200px' }}>
                                        <Typography sx={{ fontWeight: '400', textTransform: 'uppercase', fontFamily: 'Quicksand', fontSize: "18px", color: markLabelColor, paddingLeft: '16px' }}>
                                            DECISION MAKING
                                        </Typography>
                                        <Typography sx={{ fontWeight: '400', fontFamily: 'Quicksand', fontSize: "26px", color: markLabelColor, paddingLeft: '16px' }}>
                                            OVERVIEW
                                        </Typography>
                                    </Box>

                                    <Box component="img" sx={{ display: { xs: 'none', sm: 'block' } }} alt="Org Image" src={process.env.PUBLIC_URL + "/images/blank.png"} />

                                    <Box component="img"
                                        sx={{ display: "flex", height: '130px', paddingTop: '20px' }}
                                        alt="Org Image" src={process.env.PUBLIC_URL + "/images/"+backgroundPictures[8]} />
                                </Box>
                                <Box width='100%'>
                                <Line data={data9} options={options} />
                                </Box>
                            </Box>

                            <Box ref={chartRef10} className="section"
                                width='auto'
                           
                                justifyContent='center'
                                sx={{ maxWidth: '400px', width:'100%', backgroundColor: backgroundColor[9] }}
                            >
                                <Box width='100%'
                                    display='flex'
                                    justifyContent='space-between !important' paddingTop='5px'>
                                    <Box sx={{ maxWidth: '200px' }}>
                                        <Typography sx={{ fontWeight: '400', textTransform: 'uppercase', fontFamily: 'Quicksand', fontSize: "18px", color: markLabelColor, paddingLeft: '16px' }}>
                                            SUSTAINABILITY
                                        </Typography>
                                        <Typography sx={{ fontWeight: '400', fontFamily: 'Quicksand', fontSize: "26px", color: markLabelColor, paddingLeft: '16px' }}>
                                            OVERVIEW
                                        </Typography>
                                    </Box>

                                    <Box component="img" sx={{ display: { xs: 'none', sm: 'block' } }} alt="Org Image" src={process.env.PUBLIC_URL + "/images/blank.png"} />

                                    <Box component="img"
                                        sx={{ display: "flex", height: '130px', paddingTop: '20px' }}
                                        alt="Org Image" src={process.env.PUBLIC_URL + "/images/"+backgroundPictures[9]} />
                                </Box>
                                <Box width='100%'>
                                <Line data={data10} options={options} />
                                </Box>
                            </Box>
                            
                            </>)}
                    </Box>


                    <Box
                    width='100%'
                    display='flex'
                    justifyContent='center'
                    sx={{ paddingTop: '20px', paddingBottom: '40px', backgroundColor: '#DFECFF' }}
                    >
                    <Box className="exclude-from-pdf" component="img"
                        justifyContent='center'
                        sx={{ paddingLeft: '20px', paddingRight: '20px', width: '100%', maxWidth: '400px', display:displayDownload }}
                        alt="Org Image"
                        src={process.env.PUBLIC_URL + "/images/download-button.png"}
                        onClick={handleGeneratePDF}
                    />
                    </Box>

                </Box>
                

                <FooterContact />
            </Box>
            
        </Box>
        
         <Loader2 isloading={isLoading.toString()}/>
        </>
    );
}
export default ScoreLines;